import * as attachments from "./attachments";
import { configureStore, createSlice } from "@reduxjs/toolkit";
import * as automation from "./automation";
import * as comments from "./comments";
import * as codexAuth from "./codexAuth";
import * as diagnostics from "./diagnostics";
import * as thread from "./thread";
import { FieldConflict } from "./conflicts";
import * as history from "./history";
import {
  createBoard,
  deleteBoard,
  listTrashedBoards,
  purgeBoard,
  renameBoard,
  restoreBoard,
  saveBoard,
  setBoardOrder,
} from "./persistence";
import { subscribe } from "./sse";
import { getTicket, listBoards, loadBoard, loadTicketNotes, matchTickets } from "./state";
import { clientCorrelationId } from "./transport";
import * as theme from "./theme";

const publicApi = {
  storeTools: { configureStore, createSlice },
  listBoards,
  loadBoard,
  getTicket,
  loadTicketNotes,
  matchTickets,
  clientCorrelationId,
  saveBoard,
  createBoard,
  renameBoard,
  deleteBoard,
  listTrashedBoards,
  restoreBoard,
  purgeBoard,
  setBoardOrder,
  subscribe,
  attachments,
  automation,
  comments,
  codexAuth,
  diagnostics,
  thread,
  theme,
  history,
  FieldConflict,
};

declare global {
  interface Window {
    kanbanV1: typeof publicApi;
  }
}

window.kanbanV1 = publicApi;

export default publicApi;
